// Field schema for every homepage section. The editor renders forms from this,
// so adding a field (or a new section) only needs a change here.
// Types: text | textarea | number | cta | group | list | objectList

const header = [
  { key: "eyebrow", label: "Eyebrow (small label above title)", type: "text" },
  { key: "title", label: "Title", type: "text" },
  { key: "subtitle", label: "Subtitle", type: "textarea" },
];

export const SECTION_SCHEMAS = {
  hero: {
    label: "Hero",
    help: "Shown only when no Home Banner is active. Active banners replace this section.",
    fields: [
      { key: "eyebrow", label: "Eyebrow", type: "text" },
      { key: "title", label: "Headline (H1)", type: "text" },
      { key: "subtitle", label: "Subtitle", type: "textarea" },
      { key: "primary_cta", label: "Primary button", type: "cta" },
      { key: "secondary_cta", label: "Secondary button", type: "cta" },
      { key: "image", label: "Image URL (optional — defaults to featured product)", type: "text" },
    ],
  },
  trust: {
    label: "Trust Strip",
    fields: [{ key: "items", label: "Items", type: "list" }],
  },
  collection: {
    label: "Collection / Products",
    help: "Layout switches automatically: 1 active product → spotlight, 2+ → grid.",
    fields: [
      { key: "single", label: "Copy when there is 1 product", type: "group", fields: header },
      { key: "multiple", label: "Copy when there are 2+ products", type: "group", fields: header },
      { key: "cta", label: "View all button (grid only)", type: "cta" },
    ],
  },
  story: {
    label: "Brand Story",
    fields: [
      { key: "eyebrow", label: "Eyebrow", type: "text" },
      { key: "title", label: "Title", type: "text" },
      { key: "body", label: "Paragraphs", type: "list", multiline: true },
      {
        key: "stats",
        label: "Stats (use real numbers only)",
        type: "objectList",
        fields: [
          { key: "value", label: "Value", type: "text" },
          { key: "label", label: "Label", type: "text" },
        ],
      },
      { key: "cta", label: "Button", type: "cta" },
      { key: "image", label: "Image URL (optional)", type: "text" },
    ],
  },
  scent: {
    label: "Scent Profile",
    help: "Uses the fragrance notes of the featured product. Hidden if no notes exist.",
    fields: [
      { key: "eyebrow", label: "Eyebrow", type: "text" },
      { key: "title", label: "Title — {product} is replaced by the product name", type: "text" },
      { key: "subtitle", label: "Subtitle", type: "textarea" },
      { key: "longevity", label: "Longevity value", type: "text" },
      { key: "longevity_label", label: "Longevity label", type: "text" },
    ],
  },
  craft: {
    label: "Craft Process",
    fields: [
      ...header,
      {
        key: "steps",
        label: "Steps",
        type: "objectList",
        fields: [
          { key: "title", label: "Title", type: "text" },
          { key: "description", label: "Description", type: "textarea" },
        ],
      },
    ],
  },
  promise: {
    label: "Promise / Guarantees",
    fields: [
      ...header,
      {
        key: "items",
        label: "Promises",
        type: "objectList",
        fields: [
          { key: "title", label: "Title", type: "text" },
          { key: "body", label: "Text", type: "textarea" },
        ],
      },
    ],
  },
  reviews: {
    label: "Reviews",
    help: "Shows approved brand reviews once the count reaches the minimum below.",
    fields: [...header, { key: "min_reviews", label: "Minimum approved reviews to show", type: "number" }],
  },
  faq: {
    label: "FAQ",
    help: "Questions are managed in the FAQs tab.",
    fields: [
      { key: "eyebrow", label: "Eyebrow", type: "text" },
      { key: "title", label: "Title", type: "text" },
    ],
  },
  newsletter: {
    label: "Newsletter",
    fields: [
      { key: "title", label: "Title", type: "text" },
      { key: "subtitle", label: "Subtitle", type: "textarea" },
      { key: "button_text", label: "Button text", type: "text" },
      { key: "success_message", label: "Success message", type: "text" },
    ],
  },
};
